import { pagesWithDisabledIntercom } from 'src/utils/capabilities';

export const showIntercom = userData => {
  if (window.Intercom) {
    let isShowIntercom = true;
    pagesWithDisabledIntercom.forEach(pageUrl => {
      if (window.location.href.includes(pageUrl)) isShowIntercom = false;
    });

    if (isShowIntercom) {
      const { first_name, last_name, roles } = userData;

      const app_id = window.config.intercom.id;
      const is_distributor = roles.some(
        r => r === 'agent' || r === 'principal_agent',
      );
      const user = {
        app_id,
        is_distributor,
        name: `${first_name} ${last_name}`,
      };
      window.Intercom('boot', user);
      window.Intercom('update');
      window.Intercom('show');
      window.Intercom('hide');
    } else window.Intercom('shutdown');
  }
};
